import {Link} from 'react-router-dom';
import React from 'react';
import routes from '../../../routes';
import {withTranslationsAsProps} from '../../../components/translations';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_LEFT__16} from '@homeaway/svg-defs/lib/defs/CHEVRON_LEFT__16';

export function BackButton({label}) {
    return (
        <Link
            aria-label={label}
            className="btn btn-default btn-icon-responsive"
            data-wdio="tripboard-details__back-to-sctratchpad-button"
            to={routes.TRIPBOARD}
        >
            <SVGIcon className="visible-xs" markup={CHEVRON_LEFT__16} />
            <span className="hidden-xs">{label}</span>
        </Link>
    );
}

export default withTranslationsAsProps({
    'tripboards.button.back': 'label'
})(BackButton);


// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/back-button.js